// Activity action constants for audit logging
// Standard action types for tracking booking-related changes

export const ACTIVITY_ACTION = {
  STATUS: 'status',
  PRICE: 'price',
  DATE: 'date',
  TIME: 'time',
  PEOPLE: 'people',
  MOVERS: 'movers',
  TRASH: 'trash',
  RESTORE: 'restore',
  NOTE: 'note',
  NOTE_DELETE: 'note-delete',
  SETTINGS: 'settings',
  ERROR: 'error',
  BOOKING_FORM_ERROR: 'booking_form_error',
  LOGIN: 'login',
  LOGOUT: 'logout',
  BOOKING_CREATED: 'booking_created',
  USER_CREATED: 'user_created',
  USER_UPDATED: 'user_updated',
  USER_DELETED: 'user_deleted',
  USER_PASSWORD_RESET: 'user_password_reset',
  USER_STATUS_CHANGED: 'user_status_changed',
  USER_ROLE_CHANGED: 'user_role_changed',
  PERMISSIONS_UPDATED: 'permissions_updated',
  PAYMENT_RECEIVED: 'payment_received',
};
